import { render } from "./laborOfflineInfo.vue?vue&type=template&id=5ffa69c5&scoped=true"
import script from "./laborOfflineInfo.vue?vue&type=script&lang=js"
export * from "./laborOfflineInfo.vue?vue&type=script&lang=js"

import "./laborOfflineInfo.vue?vue&type=style&index=0&id=5ffa69c5&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffa69c5"]])

export default __exports__